import PropTypes from "prop-types";
import { useFormikContext } from "formik";

import ErrorMessage from "../Errors/ErrorMessage";

const Text = ({
  title,
  name = "",
  className,
  containerClass = "",
  serverError,
  formikOnChange = true,
  onChange,
  value,
  labelClass,
  disabled = false,
}) => {
  const { errors, handleChange, values } = useFormikContext();
  return (
    <div className={`form-group ${containerClass}`}>
      <label
        className={`f-13 text-left ${labelClass} d-flex flex-row justify-content-start mx-1`}
      >
        {title}
      </label>
      <input
        disabled={disabled}
        type='text'
        name={name}
        value={formikOnChange ? values[name] : value}
        onChange={(e) => {
          if (!disabled) {
            formikOnChange ? handleChange(e) : onChange(e.target.value);
          }
        }}
        className={`form-control ${className}`}
      />
      <ErrorMessage error={errors[name] ? errors[name] : serverError} />
    </div>
  );
};

Text.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  containerClass: PropTypes.string,
  serverError: PropTypes.any,
  formikOnChange: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
  disabled: PropTypes.bool,
};

export default Text;
